export default __webpack_public_path__ + "static/media/5.506401c3.png";